// Shared form option lists for CyberSecurity4Charities.org

export const SECTORS = [
  "Education",
  "Health & Medical",
  "Human Rights",
  "Environment & Conservation",
  "Animal Welfare",
  "Disaster Relief",
  "Food Security",
  "Housing & Shelter",
  "Arts & Culture",
  "Faith-Based",
  "Veterans & Military",
  "Youth & Children",
  "Women Empowerment",
  "Legal Aid",
  "Immigration & Refugees",
  "Technology & Digital Inclusion",
  "Other",
];

export const TEAM_SIZES = ["1–5", "6–15", "16–50", "51–200", "200+"];

export const REFERRAL_SOURCES = [
  "Google Search",
  "Social Media",
  "Word of Mouth",
  "Conference/Event",
  "Partner Referral",
  "LinkedIn",
  "Other",
];

export const GENDERS = ["Male", "Female", "Non-binary", "Prefer not to say"];

export const OCCUPATIONS = [
  "IT Professional",
  "Cybersecurity Analyst",
  "Volunteer",
  "Nonprofit Staff",
  "Student",
  "Researcher",
  "Donor",
  "Journalist",
  "Developer",
  "Other",
];

export const INTERESTS = [
  "Volunteering for Charities",
  "Donating to the Cause",
  "Cybersecurity Awareness",
  "Threat Intelligence",
  "Networking with Nonprofits",
  "Accessing CyberSecurity Tools",
  "Learning / Education",
  "Getting CyberSecurity Support",
];

export const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan",
  "Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi",
  "Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo (Brazzaville)","Congo (Kinshasa)","Costa Rica","Côte d'Ivoire","Croatia","Cuba","Cyprus","Czechia",
  "Denmark","Djibouti","Dominica","Dominican Republic",
  "Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia",
  "Fiji","Finland","France",
  "Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana",
  "Haiti","Honduras","Hungary",
  "Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy",
  "Jamaica","Japan","Jordan",
  "Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan",
  "Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg",
  "Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar",
  "Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia","Norway",
  "Oman",
  "Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal",
  "Qatar",
  "Romania","Russia","Rwanda",
  "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria",
  "Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu",
  "Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan",
  "Vanuatu","Vatican City","Venezuela","Vietnam",
  "Yemen",
  "Zambia","Zimbabwe",
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_4aaf0379-533a-463e-bf58-955400fd99f9/artifacts/90vhlsp8_LOGO%20-%20CyberSecurity4Charities.Org.png";
